import axiosInstance from '../utils/axiosConfig';

/**
 * My Desk API.
 *
 * All endpoints are per-user and server-scoped: the backend decides which
 * widget types this user may add and re-checks access on every data call,
 * so nothing here needs to (or can) grant access.
 */
export const myDeskService = {
  async getLayout() {
    const response = await axiosInstance.get('/api/dashboard/my-desk/layout/');
    return response.data;
  },

  async saveLayout(widgets) {
    const response = await axiosInstance.put('/api/dashboard/my-desk/layout/', { widgets });
    return response.data;
  },

  async getCatalog() {
    const response = await axiosInstance.get('/api/dashboard/my-desk/catalog/');
    return response.data;
  },

  async getWidgetData(widgetId) {
    const response = await axiosInstance.get(`/api/dashboard/my-desk/widgets/${encodeURIComponent(widgetId)}/data/`);
    return response.data;
  },

  async pinStatus(entityType, objectId) {
    const response = await axiosInstance.get('/api/dashboard/my-desk/pins/', {
      params: { entity_type: entityType, object_id: objectId },
    });
    return response.data;
  },

  async pin(entityType, objectId) {
    const response = await axiosInstance.post('/api/dashboard/my-desk/pins/', {
      entity_type: entityType,
      object_id: objectId,
    });
    return response.data;
  },

  async pinSearch(query) {
    const response = await axiosInstance.get('/api/dashboard/my-desk/pin-search/', { params: { q: query } });
    return response.data;
  },
};

export default myDeskService;
